import { useCallback } from "react";
import { useAppSelector } from "redux/hooks";
import selectEntity from "module/staff/redux/selector/selectEntity";
import { EntityType } from "module/entity/types";
import { MyInventoryCheckInterface } from "module/inventoryCheck/types";

interface Result {
  getReadableIdentifier: (id: string) => string;
}

const useMyMaintenanceTaskReadableIdentifier = (): Result => {
  const selectEntityHelper = useAppSelector(selectEntity);
  const getReadableIdentifier = useCallback(
    (id: string): string => {
      const myEntity = selectEntityHelper({
        id,
        type: EntityType.inventoryCheck,
      }) as MyInventoryCheckInterface;
      return myEntity.data.reportingNumber as string;
    },
    [selectEntityHelper]
  );

  return {
    getReadableIdentifier,
  };
};

export default useMyMaintenanceTaskReadableIdentifier;
